import get from '@pkg/utils/objects/get';

/**
 * @param {string} property
 * @return {object[]}
 */
export default function numeric(property) {
  return (a, b) => get(a, property, 0) - get(b, property, 0);
}
